import { render, staticRenderFns } from "./dataLabelDetail.vue?vue&type=template&id=3633261d&scoped=true"
import script from "./dataLabelDetail.vue?vue&type=script&lang=js"
export * from "./dataLabelDetail.vue?vue&type=script&lang=js"
import style0 from "./dataLabelDetail.vue?vue&type=style&index=0&id=3633261d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3633261d",
  null
  
)

export default component.exports